import { Image } from "@nextui-org/react";
import { NftDataType } from "../../lib/types";
import styles from "./PriceCard.module.scss";
import { Typography } from "@mui/material";

interface Props {
  nft: NftDataType;
  selected: boolean;
  onClick: () => void;
}

const NftCard = ({ nft, selected, onClick }: Props) => {
  return (
    <div
      className={`flex flex-col relative w-full h-full cursor-pointer ${selected && "border-2 border-white"}`}
      onClick={() => onClick()}
    >
      {/* <img className='w-full h-auto' src={nft.image}/> */}
      <Image
        src={(nft.image ?? "").replace(
          "https://dummified-traitshop.s3.us-east-2.amazonaws.com",
          "https://d8jlyh1kalkiz.cloudfront.net",
        )}
        alt=""
        width={200}
        height={200}
        className="w-full h-auto"
      />
      {/* <div
        className={`w-full absolute bottom-0 flex justify-between px-[10px] py-[5px]`}
      >
        <span className="text-[12px] font-bold" style={{ color: "white" }}>
          {nft.projectname} #{nft.nftname}
        </span>
      </div> */}
      {nft.projectname ? (
        <div
          className={`w-full absolute bottom-0 flex justify-center text-[#E9A623] px-[10px] py-[5px] ${styles.pricePanel} ${selected && "text-white"}`}
        >


          <Typography variant="h6" component="div" sx={{
            display: 'flex',
            justifyContent: 'center',
            fontFamily: "sans-serif",
            fontSize: "18px",
            fontWeight: 100,
            background: 'linear-gradient(90deg, rgb(216, 180, 254) 0%, rgb(167, 139, 250) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            {nft.projectname} #{nft.nftname}
          </Typography>
        </div>
      ) : (
        <div
          className={`w-full absolute bottom-0 flex justify-center text-[#E9A623] px-[10px] py-[5px] ${styles.pricePanel} ${selected && "text-white"}`}
        >
          <span className="text-[18px] font-bold">{nft.projectname}</span>
        </div>
      )}
    </div>
  );
};

export default NftCard;
